import { Picker } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { convertStyleData } from '@utils/tools';

import './AnonymousEleCustomComponent.less';

/**
 * type: 'anonymous-ele'
 * 组件：动态表单：匿名组件
 */
export default function AnonymousEleCustomComponent(props) {
  /**
   * @desc 传入数据
   */
  const data = props.data;
  const formCompindex = props.formCompindex;    // 动态表单索引
  const form_data = props.form_data || {};      // 动态表单传入

  /**
   * @desc 组件配置对象
   */
  const customFeature = data.customFeature;
  /**
   * @desc 样式数据处理
   */
  const styleObj = convertStyleData(data.style);

  const titleStyleObj = convertStyleData(customFeature.titleStyle);
  titleStyleObj['height'] = titleStyleObj['lineHeight'];

  const contentStyleObj = convertStyleData(customFeature.contentStyle);
  contentStyleObj['height'] = contentStyleObj['lineHeight'];

  /**
   * 组件内容处理
   */ 
  const contents = customFeature.contents;
  /**
   * @desc 处理成组件需要的格式
   */
  contents.forEach((item) => {
    item['optionsData'] = item['options'].map((item, index) => ({
      label: item,
      value: item
    }));
  });

  const changeAnonymous = (v, i) => {
    let value = v;
    let index = i;
    let pageInstance = app.getAppCurrentPage();
    let compindex    = props.index;
    let formcompindex = formCompindex;
    let segment      = customFeature.segment;
    let componentKey = 'eles[' + formcompindex +'].content[' + compindex + ']';
    let datakey = `eles[${formCompindex}].form_data.${customFeature.segment}`;

    if (!segment) {
      app.showModal({
        content: '该组件【匿名组件】未绑定字段 请在电脑编辑页绑定后使用'
      })
      return;
    }

    let newdata = {};
    newdata[componentKey + '.anonymous'] = data.anonymous || [];
    newdata[componentKey + '.anonymous'][index] = value;
    newdata[datakey] = value == '实名提交' ? (app.globalData.userInfo.nickname || '获取失败') : '匿名提交';

    pageInstance.setData(newdata);
  }

  return (
    <div className="custom-component anonymous-ele">
      <div className="drop-down" style={styleObj}>
        <div style={titleStyleObj}>{customFeature.name}</div>
        {contents.map((item, index) => (
          <Picker key={index}
                  cols={1}
                  data={item.optionsData}
                  onChange={(value) => changeAnonymous(value, index)}>
            <div className="picker-title" style={contentStyleObj}>
              {(data.anonymous && data.anonymous[index]) || item.name}
            </div>
          </Picker>
        ))}
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/custom-component/anonymous-ele-custom-component/AnonymousEleCustomComponent.jsx